export const FORM_ID = "subscriptionForm";

export const RECAPTCHA_ACTION = "SUBMIT_CONTACT_FORM";

export const EMAIL_SUBSCRIPTION_API_PATH = "/api/email-subscription";
